import axios from 'axios';

const reactAppData = window.itu_slot_form || {};

const checkUser = async (userid) => {
  try {
    // Use local WordPress proxy to avoid CORS issues with external Azure SSO
    const baseUrl = reactAppData.ajax_url || '/wp-json/itu-wp-api/v1/';
    const res = await axios.get(`${baseUrl}sso/check`, {
      withCredentials: true,
    });
    return res.status === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default checkUser;
